// components/AuthSuccess.js
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Typography, CircularProgress, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const AuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

useEffect(() => {
  const token = searchParams.get('token');
  const userParam = searchParams.get('user');

  if (token && userParam) {
    try {
      const user = JSON.parse(decodeURIComponent(userParam));
      login(token, user);
      console.log(user)
      // Check if user needs to complete profile
      if (user.age === "" || user.sex === ""|| user.user_phone === "") {
        navigate('/complete-profile');
      } else {
        navigate('/');
      }
    } catch (error) {
      console.error('Error parsing user data:', error);
      navigate('/login?error=auth_failed');
    }
  } else {
    navigate('/login?error=auth_failed');
  }
}, [searchParams, login, navigate]);

  return (
    <Container maxWidth="sm" sx={{ py: 4, textAlign: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CircularProgress />
        <Typography variant="h6">جار تسجيل الدخول ...</Typography>
      </Box>
    </Container>
  );
};

export default AuthSuccess;